module.exports = __webpack_public_path__ + "img/tiktok_1@4x.9dee10c5.png";